const scryptlib = require('mvc-scrypt')
module.exports = scryptlib
